import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@material-ui/core';
// import { useSelector } from 'dva';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import RefreshIcon from '@material-ui/icons/Refresh';
import { TextFieldCom } from '../../../components/FormType';
import RuleML from './RuleML';
import DetailMLStyled from './DetailMLStyles';

// eslint-disable-next-line no-unused-vars
export default ({
  queryType,
  control,
  errors,
  setValue,
  tagCollectionInfo = null,
  setError,
  clearErrors,
  getValues,
  handleAddRuleData,
  handleAddRuleDataDelete,
  handleAddRuleDetailData,
  handleAddRuleDetailDataDelete,
  handleDetailDelete,
  handleRefreshDetail,
  setFieldValue,
  ruleLabelDirectoryList,
}) => {
  // const { labelDirectoryList } = useSelector((state) => state.labelManage);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState();
  useEffect(() => {
    if (tagCollectionInfo) {
      tagCollectionInfo.forEach((item) => {
        setValue(`name-${item.id}`, item.name);
        setValue(`remark-${item.id}`, item.remark);
      });
    }
  }, [setValue, tagCollectionInfo]);
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseSure = () => {
    setOpen(false);
    handleDetailDelete({
      id: deleteId,
    });
    setDeleteId();
  };
  return (
    <DetailMLStyled>
      <Box>
        {tagCollectionInfo &&
          Array.isArray(tagCollectionInfo) &&
          tagCollectionInfo.length > 0 &&
          tagCollectionInfo.map((item, index) => {
            return (
              <Box
                key={index}
                borderRadius="12px"
                bgcolor="background.paper"
                p={4}
                mb={0.5}
              >
                {/*上面部分s*/}
                <Box display="flex" justifyContent="space-between" gap="0 62px">
                  <Box flex="1">
                    <TextFieldCom
                      autoFocus={false} //If true, the input element is focused during the first mount.
                      initLabel={true} //自定义的label是否显示
                      showLabel={false} //是否需要显示label
                      placeholder="请输入集合名称"
                      queryType={queryType} //detail不可编辑用于详情
                      helperText="" //用于校验的提醒文字
                      name={`name-${item.id}`}
                      label="集合名称" //label
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                      isParseInt={false} //true 只能输入正整数，false可以输入小数
                      realName="name"
                      setFieldValue={setFieldValue}
                      parameter={{
                        id: item.id,
                      }}
                      rules={{
                        required: true, //是否是必填项true 必填 false 非必填
                        maxLength: 20,
                      }}
                    />
                  </Box>
                  <Box flex="3">
                    <TextFieldCom
                      autoFocus={false} //If true, the input element is focused during the first mount.
                      initLabel={true} //自定义的label是否显示
                      showLabel={false} //是否需要显示label
                      placeholder="请输入备注"
                      queryType={queryType} //detail不可编辑用于详情
                      helperText="" //用于校验的提醒文字
                      name={`remark-${item.id}`}
                      label="备注" //label
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      isPositiveNumber={false} //true 只能输入正数，false可以输入负数
                      isParseInt={false} //true 只能输入正整数，false可以输入小数
                      realName="remark"
                      setFieldValue={setFieldValue}
                      parameter={{
                        id: item.id,
                      }}
                      rules={{
                        required: false, //是否是必填项true 必填 false 非必填
                        maxLength: 200,
                      }}
                    />
                  </Box>
                </Box>
                {/*上面部分e*/}
                <Box
                  sx={{
                    fontSize: 12,
                    color: '#212100',
                    marginBottom: '23px',
                    marginTop: '20px',
                  }}
                >
                  <span style={{ color: 'red' }}>*</span>详细设置
                </Box>
                {/*满足规则s*/}
                <Box>
                  <RuleML
                    ruleList={item.tagCollectionRuleIn}
                    detailId={item.id}
                    tagCollectionInfo={tagCollectionInfo}
                    queryType={queryType}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    setError={setError}
                    clearErrors={clearErrors}
                    getValues={getValues}
                    handleAddRuleData={handleAddRuleData}
                    handleAddRuleDataDelete={handleAddRuleDataDelete}
                    handleAddRuleDetailData={handleAddRuleDetailData}
                    handleAddRuleDetailDataDelete={
                      handleAddRuleDetailDataDelete
                    }
                    setFieldValueP={setFieldValue}
                    cLabel="满足"
                    pid={item.id}
                    ruleLabelDirectoryList={ruleLabelDirectoryList}
                  />
                </Box>
                {/*满足规则e*/}
                {/*排除规则s*/}
                <Box sx={{ marginTop: '30px' }}>
                  <RuleML
                    ruleList={item.tagCollectionRuleOut}
                    detailId={item.id}
                    tagCollectionInfo={tagCollectionInfo}
                    queryType={queryType}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    setError={setError}
                    clearErrors={clearErrors}
                    getValues={getValues}
                    handleAddRuleData={handleAddRuleData}
                    handleAddRuleDataDelete={handleAddRuleDataDelete}
                    handleAddRuleDetailData={handleAddRuleDetailData}
                    handleAddRuleDetailDataDelete={
                      handleAddRuleDetailDataDelete
                    }
                    setFieldValueP={setFieldValue}
                    cLabel="排除"
                    pid={item.id}
                    ruleLabelDirectoryList={ruleLabelDirectoryList}
                  />
                </Box>
                {/*排除规则e*/}
                {queryType !== 'detail' && (
                  <Box
                    display="flex"
                    justifyContent="center"
                    gap="0 23px"
                    marginTop="60px"
                  >
                    {tagCollectionInfo.length > 1 && (
                      <Box
                        sx={{
                          width: '35px',
                          height: '35px',
                          padding: '6px 7px',
                          borderRadius: '50%',
                          background: '#fafafa',
                          boxShadow:
                            '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                        }}
                        onClick={() => {
                          setOpen(true);
                          setDeleteId(item.id);
                        }}
                      >
                        <DeleteForeverIcon
                          sx={{
                            width: '100%',
                            height: '100%',
                            color: 'rgba(0, 0, 0, 0.87)',
                          }}
                        />
                      </Box>
                    )}
                    <Box
                      sx={{
                        width: '35px',
                        height: '35px',
                        padding: '6px 7px',
                        borderRadius: '50%',
                        background: '#fafafa',
                        boxShadow:
                          '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 1px 18px 0px rgba(0,0,0,0.12), 0px 6px 10px 0px rgba(0,0,0,0.14)',
                      }}
                      onClick={() => {
                        handleRefreshDetail({ id: item.id });
                      }}
                    >
                      <RefreshIcon
                        sx={{
                          width: '100%',
                          height: '100%',
                          color: 'rgba(0, 0, 0, 0.87)',
                        }}
                      />
                    </Box>
                  </Box>
                )}
              </Box>
            );
          })}
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ width: '200px' }}
          >
            确认删除吗？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={handleClose}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleCloseSure}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </DetailMLStyled>
  );
};
